import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {
  select_renderJobsByStatusChart,
  select_jobsByStatus_chartData,
  select_renderJobsByTypeChart,
  select_jobsByType_chartData,
  select_jobsByUrl_max,
  select_renderJobsByUrlChart,
  select_jobsByUrl_chartData,
  select_renderDatabasesByAppChart,
  select_databasesByAppVersion_chartData,
  select_renderDatabasesByDatabaseChart,
  select_databasesByDatabaseVersion_chartData,
  select_totals_hydrate,
} from 'redux/totals/selectors'
import {Container, Stack} from '@mdsol/onex-design'
import {BarChart, DonutChart} from '@mdsol/onex-design/Charts'

import HomeControl from 'components/view/HomeControl'
import Loading from 'components/common/charts/Loading'

import './home.scss'

const Home: FC = () => {
  const height = 400
  const width = 600

  const renderJobsByStatusChart = useSelector(select_renderJobsByStatusChart)
  const jobsByStatusData = useSelector(select_jobsByStatus_chartData)

  const renderJobsByTypeChart = useSelector(select_renderJobsByTypeChart)
  const jobsByTypeData = useSelector(select_jobsByType_chartData)
  const jobsByTypeMax = useSelector(select_jobsByUrl_max)

  const renderJobsByUrlChart = useSelector(select_renderJobsByUrlChart)
  const jobsByUrlData = useSelector(select_jobsByUrl_chartData)

  const renderDatabasesByDatabaseChart = useSelector(select_renderDatabasesByDatabaseChart)
  const databasesByDatabaseVersionData = useSelector(select_databasesByDatabaseVersion_chartData)

  const renderDatabasesByAppChart = useSelector(select_renderDatabasesByAppChart)
  const databasesByAppVersionData = useSelector(select_databasesByAppVersion_chartData)

  const hydrate = useSelector(select_totals_hydrate)

  return (
    <Container id='overview' fluid>
      <HomeControl />

      <Stack direction='horizontal' gap={3} className='charts-stack'>
        {renderJobsByStatusChart && hydrate
          ? (
            <DonutChart
              dataTestId='jobs-byStatus-donut-chart'
              className='donut-chart'
              annotationText='Total'
              data={jobsByStatusData}
              legendLayout='horizontal'
              title={'Jobs'}
              subtitle={'by status'}
              height={height}
              width={width}
            />
          ) : <Loading />
        }

        {renderJobsByTypeChart && hydrate
          ? (
            <DonutChart
              dataTestId='jobs-byType-donut-chart'
              className='donut-chart'
              annotationText='Total'
              data={jobsByTypeData}
              legendLayout='horizontal'
              title={'Jobs'}
              subtitle={'by type'}
              height={height}
              width={width}
            />
          ) : <Loading />
        }
      </Stack>

      <Stack direction='horizontal' gap={3} className='charts-stack'>
        {renderJobsByUrlChart && hydrate
          ? (
            <BarChart
              dataTestId='jobs-byUrl-donut-chart'
              className='bar-chart'
              annotationText='Total'
              data={jobsByUrlData}
              yAxisMax={jobsByTypeMax}
              showLegend
              title={'Jobs'}
              subTitle={'by url (top 25)'}
              height={height}
            />
          ) : <Loading chartType='bar-chart' />
        }
      </Stack>

      <Stack direction='horizontal' gap={3} className='charts-stack'>
        {renderDatabasesByDatabaseChart && hydrate
          ? (
            <DonutChart
              dataTestId='databases-byDatabaseVersion-bar-chart'
              className='donut-chart'
              annotationText='Total'
              data={databasesByDatabaseVersionData}
              legendLayout='horizontal'
              title={'Databases'}
              subtitle={'by version'}
              height={height}
              width={width}
            />
          ) : <Loading />
        }

        {renderDatabasesByAppChart && hydrate
          ? (
            <DonutChart
              dataTestId='databases-byAppVersion-donut-chart'
              className='donut-chart'
              annotationText='Total'
              data={databasesByAppVersionData}
              legendLayout='horizontal'
              title={'Databases'}
              subtitle={'by app version'}
              height={height}
              width={width}
            />
          ) : <Loading />
        }
      </Stack>
    </Container>
  )
}

export default Home
